<template>
  <div class="page-product-table-box mt15">

    <div class="tablebox">
      <el-table 
        ref="multipleTable" 
        :data="tabledata"
        tooltip-effect="dark" 
        style="width: 100%"
        size="mini"
      >
        <el-table-column align="left" label="ASSETID" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-html="scope.row.AssetIdIcon"></span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('jgjk.s15')" width="110">
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
          </template>
        </el-table-column>
        <el-table-column align="center" prop='skuMap' :label="$t('jgjk.s266')" width="110"></el-table-column>
        <el-table-column align="center" prop='SkuTotalAmountStr' :label="$t('jgjk.s267')" width="80"></el-table-column>
        <el-table-column align="center" prop='CurrentPrice' :label="$t('jgjk.s23')" width="100"></el-table-column>
        <el-table-column align="center" prop='FinalPrice' :label="$t('jgjk.s24')" width="100"></el-table-column>
        <el-table-column align="center" prop='MonitorPrice' :label="$t('jgjk.s25')" width="80"></el-table-column>
        <el-table-column align="center" prop='MarginPrice' :label="$t('jgjk.s26')" width="80"></el-table-column>
        <el-table-column align="center" prop='MarginPercent' :label="$t('report.s38')" width="80"></el-table-column>
      </el-table>
    </div>

	</div>
</template>

<script>
export default {
  props: {
    tabledata: Array
  },

	mounted(){
  },

	methods: {
	}
	
}
</script>
